module.exports = __webpack_public_path__ + "static/media/riley-lose.23fcc0ef.jpg";